// src/components/EditorWorkbench.js
import React, { useEffect, useRef } from "react";
import "./MuultiStyle.css";

export default function EditorWorkbench({
                                            active,
                                            title,
                                            onClose,
                                            children,
                                            right = null,        // optional header actions (e.g., Save)
                                            footer = null,       // optional sticky footer
                                            id = "editor-workbench",
                                            scrollOnOpen = true, // auto-scroll into view when opened
                                            className = "",      // extra classes (e.g., "wide")
                                        }) {
    // ⬇️ Hooks must be called unconditionally (before any early returns)
    const ref = useRef(null);

    // Scroll into view on open
    useEffect(() => {
        if (active && scrollOnOpen && ref.current) {
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    }, [active, scrollOnOpen]);

    // ESC to close
    useEffect(() => {
        if (!active) return;
        const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [active, onClose]);

    // Now it’s safe to early-return
    if (!active) return null;

    return (
        <div ref={ref} id={id} className={`editor-workbench ${className}`}>
            <div className="editor-workbench__bar">
                <h3 className="editor-workbench__title">{title}</h3>
                <div className="editor-workbench__actions">
                    {right}
                    <button className="muulti-button" onClick={onClose} aria-label="Close editor">
                        Close
                    </button>
                </div>
            </div>

            <div className="editor-workbench__body">
                {children}
            </div>

            {footer && (
                <div className="editor-workbench__footer">
                    {footer}
                </div>
            )}
        </div>
    );
}
